import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { get } from 'lodash';
import { ChatBubbleLeftIcon } from '@heroicons/react/24/outline';

const PersonalMessageNotification = ({ notification }) => {
  const intl = useIntl();
  const actorName = get(notification, 'actor.allowed_name', 'Someone');
  const conversationId = get(notification, 'notifiable.conversation.id');
  
  // Build the message URL - use succession messages to stay within succession interface
  const messageUrl = conversationId ? `/succession/messages?room_id=${conversationId}` : '/succession/messages';

  return (
    <div className="flex items-start space-x-3">
      {/* Icon */}
      <div className="flex-shrink-0">
        <div className="w-10 h-10 bg-succession-primary-10 rounded-full flex items-center justify-center">
          <ChatBubbleLeftIcon className="w-5 h-5 text-succession-primary" />
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="text-sm">
          <span className="font-medium text-succession-text-primary">{intl.formatMessage({ id: 'succession.notifications.personal_message.new_message' })}</span>
          <span className="text-succession-text-secondary">{intl.formatMessage({ id: 'succession.notifications.personal_message.from' })}</span>
          <span className="font-medium text-succession-text-primary">{actorName}</span>
        </div>
        
        <div className="mt-1 text-sm text-succession-text-secondary">
          {intl.formatMessage({ id: 'succession.notifications.personal_message.body' })}
        </div>

        {/* Call to action */}
        <div className="mt-3">
          <a
            href={messageUrl}
            onClick={(e) => {
              e.stopPropagation(); // Prevent parent click handler from interfering
              window.location.href = messageUrl; // Ensure navigation happens
            }}
            className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-succession-primary hover:bg-succession-primary-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--succession-focus-ring)] transition-colors duration-150"
          >
            {intl.formatMessage({ id: 'succession.notifications.personal_message.view_message' })}
          </a>
        </div>
      </div>
    </div>
  );
};

PersonalMessageNotification.propTypes = {
  notification: PropTypes.shape({
    actor: PropTypes.shape({
      allowed_name: PropTypes.string,
    }),
    notifiable: PropTypes.shape({
      conversation: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default PersonalMessageNotification; 